module.exports = __webpack_public_path__ + "img/kz_pic5.583969c2.png";